import { flow, Instance, types } from 'mobx-state-tree'
import { SettingsApi } from '../../services/api-objects/SettingsApi'
import { flatten } from 'ramda'

export const UtilityStoreModel = types
  .model('UtilityStore')
  .props({
    status: types.frozen(),
    sharedDevice: types.maybe(types.boolean),
    mimeTypes: types.frozen(),
    sourceRefresh: types.map(types.number),
  })
  .actions((self) => ({
    setSourceRefresh(k, v) {
      self.sourceRefresh.set(k, v)
    },
    setSharedDevice(shared: boolean) {
      self.sharedDevice = shared
    },
    setMimeTypes(mimeTypes: any) {
      self.mimeTypes = mimeTypes
    },
    setStatus(status: any) {
      self.status = status
    },
  }))
  .views((self) => ({
    get imageMimetypes() {
      if (self.mimeTypes) {
        return self.mimeTypes.image
      }
      return []
    },
    get videoMimetypes() {
      if (self.mimeTypes) {
        return self.mimeTypes.video
      }
      return []
    },
    get audioMimetypes() {
      if (self.mimeTypes) {
        return self.mimeTypes.audio
      }
      return []
    },
    get allMimetypes() {
      if (self.mimeTypes) {
        return flatten(Object.values(self.mimeTypes))
      }
      return []
    },
    get mediaMimetypes() {
      if (self.mimeTypes) {
        return [...this.imageMimetypes, ...this.videoMimetypes, ...this.audioMimetypes]
      }
      return []
    },
    get mercuryMimetypes() {
      if (self.mimeTypes) {
        const { audio, video, document, pdf, spreadsheet, presentation, text } = self.mimeTypes
        return flatten([document, audio, video, pdf, presentation, text])
      }
      return []
    },
  }))
  .actions((self) => ({
    getMimeTypes: flow(function* () {
      try {
        const result: Awaited<ReturnType<typeof SettingsApi.getMimeTypes>> =
          yield SettingsApi.getMimeTypes()
        if (result.ok && result.data) {
          self.setMimeTypes(result.data)
        }
      } catch {
        self.setStatus('error')
      }
    }),
  }))

type UtilityStoreType = Instance<typeof UtilityStoreModel>
export interface UtilityStore extends UtilityStoreType {}
